<div *ngIf="!canRead('CIJBorculo.Logic.kpInstrument')">
    <!-- Dashboard CIJ -->
    <div fxLayout="row" fxLayoutGap="5px">
        <div>
            <mat-card *ngIf="nrOfProjectregelsPerWeekAanmaakdatum" class="dashboard-card-collection-top">
                <mat-card-header class="buttonsRight">
                    <mat-card-title>Ingekomen Instrumenten {{this.chosenYear}}</mat-card-title>
                    <mat-card-subtitle>Per week</mat-card-subtitle>
                    <div>
                        <button matSuffix mat-icon-button (click)="LastYear()" type="button" tabIndex="-1">
                            <mat-icon color="primary" >arrow_back_ios</mat-icon>
                        </button>
                        <button matSuffix mat-icon-button (click)="NextYear()" type="button" tabIndex="-1">
                            <mat-icon color="primary" >arrow_forward_ios</mat-icon>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <ng-container>
                        <canvas [chartjs]="nrOfProjectregelsPerWeekAanmaakdatum" width="1150" height="325"></canvas>
                    </ng-container>
                </mat-card-content>
            </mat-card>        
        </div>    
        <div>
            <div>
                <div>
                    <mat-card class="dashboard-card-small-top">
                        <mat-card-content>
                            <table width="100%">
                                <tr>
                                    <td width="50%">
                                        <img src="assets/CIJ-MLP-tr.png" class="dashboard-card-small-logo"/>                                    
                                    </td>
                                    <td width="50%">                                    
                                        <mat-card-subtitle>                                        
                                            <h3>{{MiLabProName}}</h3>
                                            Versie {{MiLabProVersion}}
                                            <br>                       
                                            {{MiLabProDate}}
                                        </mat-card-subtitle>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div>
                    <mat-card *ngIf="nrOfProjectenPerStatus && !canDoExact()" class="dashboard-card-small-bottom">
                        <mat-card-header>
                            <mat-card-title>Projecten</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <canvas [chartjs]="nrOfProjectenPerStatus" height="200"></canvas>
                        </mat-card-content>
                    </mat-card>
                    <mat-card *ngIf="canDoExact()" class="dashboard-card-small-bottom">
                        <mat-card-header>
                            <mat-card-title>Facturatie</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <table width="100%">
                                <tr>
                                    <td><div class="labelNumberHeaderSmall">Te Factureren</div></td>
                                    <td><div class="labelNumberHeaderSmall">ProForma</div></td>
                                    <td><div class="labelNumberHeaderSmall">Goedkeuren</div></td>
                                </tr>                            
                                <tr>
                                    <td>
                                        <a routerLink="/pakbon/factureren" >  
                                            <div class="labelNumber"><label title="Te Factureren">{{this.nrFactureren}}</label></div>
                                        </a>
                                    </td>
                                    <td>
                                        <a routerLink="/pakbon/factureren" [queryParams]="getQueryParamsProForma()">  
                                            <div class="labelNumber"><label title="ProForma">{{this.nrProForma}}</label></div>
                                        </a>
                                    </td>
                                    <td>
                                        <a routerLink="/factuur/goedkeuren" >  
                                            <div class="labelNumber"><label title="Goedkeuren">{{this.nrGoedkeuren}}</label></div>
                                        </a>
                                    </td>
                                </tr> 
                                <tr><td><br></td></tr>  
                                <tr>
                                    <td><div class="labelNumberHeaderSmall">Verzenden</div></td>
                                    <td><div class="labelNumberHeaderSmall">Exporteren</div></td>
                                    <td></td>
                                </tr>   
                                <tr>
                                    <td>
                                        <div class="labelNumber"><label title="Verzenden">{{this.nrVerzenden}}</label></div>
                                    </td>
                                    <td>
                                        <a routerLink="/factuur/exporteren" >  
                                            <div class="labelNumber"><label title="Exporteren">{{this.nrExporteren}}</label></div>
                                        </a>
                                    </td>
                                    <td>
                                        
                                    </td>
                                </tr>  
                            </table>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>    
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="5px">
        <div>
            <mat-tab-group>
                <mat-tab *ngIf="nrOfOproepenMailPerWeek">
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Verstuurde Oproepen</div>
                    </ng-template>   

                    <mat-card *ngIf="nrOfOproepenMailPerWeek" class="dashboard-card-collection-wider">
                        <mat-card-header class="buttonsRight">
                            <mat-card-title>Verstuurde Oproepen {{this.chosenYearOproepen}}</mat-card-title>
                            <mat-card-subtitle>Per week</mat-card-subtitle>
                            <div>
                                <button matSuffix mat-icon-button (click)="LastYearOproepen()" type="button" tabIndex="-1">
                                    <mat-icon color="primary" >arrow_back_ios</mat-icon>
                                </button>
                                <button matSuffix mat-icon-button (click)="NextYearOproepen()" type="button" tabIndex="-1">
                                    <mat-icon color="primary" >arrow_forward_ios</mat-icon>
                                </button>
                            </div>
                        </mat-card-header>
                        <mat-card-content>
                            <ng-container>
                                <canvas [chartjs]="nrOfOproepenMailPerWeek" width="1150" height="225"></canvas>
                            </ng-container>
                        </mat-card-content>
                    </mat-card>
                </mat-tab> 
                <mat-tab *ngIf="nrOfOproepenPerDatum">
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Openstaande Oproepen</div>
                    </ng-template> 

                    <mat-card *ngIf="nrOfOproepenPerDatum" class="dashboard-card-collection-wider">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-list-item routerLink="/oproepHistorie/oproepen" routerLinkActive="active-link" *ngIf="canRead('CIJBorculo.Logic.OproepHistorie')"><a>Openstaande Oproepen</a></mat-list-item>
                            </mat-card-title>
                            <mat-card-subtitle>per datum</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <canvas [chartjs]="nrOfOproepenPerDatum" width="1150" height="225" ></canvas>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>
                <mat-tab *ngIf="nrOfHerOproepenPerDatum">
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Heroproepen</div>
                    </ng-template> 
                    
                    <mat-card *ngIf="nrOfHerOproepenPerDatum" class="dashboard-card-collection-wider">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-list-item routerLink="/oproepHistorie/heroproepen" routerLinkActive="active-link" *ngIf="canRead('CIJBorculo.Logic.OproepHistorie')"><a>Heroproepen</a></mat-list-item>
                            </mat-card-title>
                            <mat-card-subtitle>Nog niet binnengekomen oproepen</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <canvas [chartjs]="nrOfHerOproepenPerDatum" width="1150" height="225" ></canvas>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>
                <mat-tab *ngIf="nrOfProjectregelsPerStatus">
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Planning per status</div>
                    </ng-template> 

                    <mat-card *ngIf="nrOfProjectregelsPerStatus" class="dashboard-card-collection-wider">
                        <mat-card-header>
                            <mat-card-title>
                            <mat-list-item routerLink="/projectregel/planning" routerLinkActive="active-link" [queryParams]="{ 'ni:status': '[10,11,12]'}" *ngIf="canRead('CIJBorculo.Logic.Projectregel')"><a>Planning</a></mat-list-item>
                            </mat-card-title>
                            <mat-card-subtitle>Openstaande planning per status</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <canvas [chartjs]="nrOfProjectregelsPerStatus" width="1150" height="225"></canvas>
                        </mat-card-content>
                    </mat-card>        
                </mat-tab>
            </mat-tab-group>
        </div>
        <div>
            
        </div>
    </div>
    
</div>



